var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
function escapeHtml(text) {
    return text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}
var HOT_ICON_SVG = "<svg class=\"help-hot-content-card__icon\" width=\"28\" height=\"28\" viewBox=\"0 0 28 28\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\">\n  <path d=\"M11.7215 2.93421C11.5437 4.90821 10.7275 8.60141 7.33952 12.1602C7.44032 10.847 7.14492 9.86981 6.81872 9.21601C6.63812 8.85621 6.10612 8.92621 6.02912 9.32101C5.87232 10.126 5.46632 11.3734 4.45412 13.0884C2.49552 16.4078 2.74332 25.6632 13.7711 25.6632C24.7989 25.6632 25.5409 16.0158 23.9743 12.1C22.9523 9.54501 21.4053 7.92941 20.4519 7.11461C20.1397 6.84721 19.6553 7.06141 19.6427 7.47161C19.6175 8.30461 19.4425 9.47781 18.7383 10.2646C18.7201 8.82121 17.6953 4.56661 13.2027 2.14741C12.5657 1.80441 11.7873 2.21461 11.7215 2.93421Z\" fill=\"#FF5D50\"/>\n  <path d=\"M19.2018 18.5501C19.087 17.3181 17.5428 13.9959 13.3876 11.8119C13.0978 11.6593 12.7562 11.8973 12.7996 12.2221C12.9704 13.5031 13.1538 16.0637 12.1416 17.2733C12.2522 16.1687 11.646 15.2545 11.1392 14.6945C10.9096 14.4425 10.4952 14.5671 10.442 14.9045C10.3454 15.5149 10.0906 16.4431 9.44239 17.5827C8.29159 19.6071 7.06379 22.7417 12.8486 25.6397C13.1482 25.6551 13.4548 25.6635 13.7712 25.6635C14.0778 25.6635 14.3746 25.6551 14.6658 25.6397C18.9932 24.0129 19.409 20.7733 19.2018 18.5501Z\" fill=\"#FFDF99\"/>\n</svg>";
/** 侧栏热门内容卡（默认展示 5 条，可换一换随机刷新） */
export function renderHelpHotContentCard(items, options) {
    if (options === void 0) { options = {}; }
    if (!items.length) {
        return '';
    }
    var _a = options.showShuffle, showShuffle = _a === void 0 ? false : _a;
    var shuffleBtn = showShuffle
        ? '<a href="javascript:void(0)" class="help-hot-content-card__shuffle" role="button" aria-label="换一换">换一换</a>'
        : '';
    var lis = items
        .map(function (item, index) {
        var href = escapeHtml((item.article_url || '#').trim() || '#');
        var text = escapeHtml(item.title || '');
        return "<li class=\"help-hot-content-card__item\">\n        <span class=\"help-hot-content-card__index\">".concat(index + 1, "\u3001</span>\n        <a class=\"help-hot-content-card__link\" href=\"").concat(href, "\" target=\"_blank\" rel=\"noopener\">").concat(text, "</a>\n      </li>");
    })
        .join('');
    return "<article class=\"help-hot-content-card\">\n    <header class=\"help-hot-content-card__head\">\n      ".concat(HOT_ICON_SVG, "\n      <h2 class=\"help-hot-content-card__title\">\u70ED\u95E8\u5185\u5BB9</h2>\n      ").concat(shuffleBtn, "\n    </header>\n    <ol class=\"help-hot-content-card__list\">").concat(lis, "</ol>\n  </article>");
}
/** Fisher-Yates 洗牌后取前 count 条 */
export function pickRandomHotContentItems(items, count) {
    var _a;
    if (items.length <= count) {
        return __spreadArray([], items, true);
    }
    var pool = __spreadArray([], items, true);
    for (var i = pool.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        _a = [pool[j], pool[i]], pool[i] = _a[0], pool[j] = _a[1];
    }
    return pool.slice(0, count);
}
